module.exports = __webpack_public_path__ + "static/media/superman@2x.c1c45f3e.png";